import { Injectable } from '@angular/core';
import { ResourceName } from '../../../../../backend/src/core/resource-name';
import { LambdaService } from '../../shared/core/lambda.service';
import { ReferRequest, ReferralGate } from './../../../../../backend/src/core/referral/referral.gate';
import { BoardHolderService } from './../board/board.holder.service';
import { WorkspaceHolderService } from './../workspace/workspace.holder.service';

@Injectable({
  providedIn: 'root',
})
export class ReferralService {
  constructor(
    private lambdaService: LambdaService,
    private workspaceHolderService: WorkspaceHolderService,
    private boardHolderService: BoardHolderService
  ) {}

  refer$(email: string) {
    const request: ReferRequest = {
      workspaceId: this.workspaceHolderService.currentWorkspace().id,
      personalBoardId: this.boardHolderService.myPersonalBoard()!.id,
      email,
    };

    return this.lambdaService.run$(ResourceName.referral, ReferralGate.actions.refer, request);
  }
}
